import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import Link from '~/components/link-with-previous-href';

const ImageTile = ({
  to,
  image,
  caption,
  className,
  color,
  backgroundColor,
}) => pug`
  Link.tile--image__container(to=to, className=className)
    .tile.tile--image(style={'--color-accent': '#' + color})
      .tile__content
        Img(fluid=image, backgroundColor="#" + backgroundColor)
    p.caption=caption
`;

ImageTile.defaultProps = { className: '' };

ImageTile.propTypes = {
  to: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  caption: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
};

export default ImageTile;
